import React, { Fragment } from 'react';

interface Props<T> {
  label: string;
  data: T[];
  renderItem: (item: T) => React.ReactElement<any>;
  keyExtractor: (item: T) => React.Key;
}

export default function Section<T>(props: Props<T>) {
  return (
    <section>
      {props.label && (
        <h3 className="mb-1 mt-2 text-base font-medium text-greyscale-placeholder tracking-tight">
          {props.label}
        </h3>
      )}

      {props.data.map((item) => (
        <Fragment key={props.keyExtractor(item)}>
          {props.renderItem(item)}
        </Fragment>
      ))}
    </section>
  );
}
